import { render, staticRenderFns } from "./NewDetail.vue?vue&type=template&id=4d1c9895"
import script from "./NewDetail.vue?vue&type=script&lang=js"
export * from "./NewDetail.vue?vue&type=script&lang=js"
import style0 from "./NewDetail.vue?vue&type=style&index=0&id=4d1c9895&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports